import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ReframeSection() {
  return <section className="py-8 md:py-10 px-4 bg-cream-100 relative overflow-hidden" data-id="element-185">
      {/* Decorative elements */}
      <div className="absolute -left-32 top-1/2 -translate-y-1/2 w-64 h-64 bg-dusty-rose-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-186"></div>
      <div className="absolute -right-32 top-1/2 -translate-y-1/2 w-64 h-64 bg-gold-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-187"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-188">
        <FadeIn data-id="element-189">
          <h2 className="text-2xl md:text-4xl font-bold text-center text-burgundy-900 mb-6 md:mb-12 leading-tight" data-id="element-190">
            El problema no sos vos.
            <br data-id="element-191" />
            <span className="italic font-normal text-burgundy-700" data-id="element-192">
              Es que nadie te dio el mapa de tu hijo.
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-4 md:space-y-6 text-base md:text-xl text-burgundy-800 leading-relaxed text-justify md:text-center" data-id="element-193">
          <FadeIn delay={0.1} data-id="element-194">
            <p data-id="element-195">
              Cada niño nace con una forma única de sentir, de aprender, de
              comunicarse y de necesitar amor.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-196">
            <p data-id="element-197">Pero la crianza convencional trata a todos los niños igual.</p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-198">
            <p data-id="element-199">
              Los libros hablan del niño promedio. Las apps son genéricas. Los
              consejos de otras mamás sirven para sus hijos — no para el tuyo.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-200">
            <p className="font-bold text-burgundy-900 mt-4 md:mt-8" data-id="element-201">
              CÓDIGO HIJO existe para darte algo que ningún otro recurso te da:
            </p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-202">
            <p className="font-heading text-xl md:text-3xl text-burgundy-900 font-bold italic mt-2 md:mt-4 p-4 md:p-6 bg-white/60 rounded-2xl border border-white backdrop-blur-sm shadow-sm" data-id="element-203">
              Un sistema personalizado basado en quién es tu hijo realmente —
              desde el momento en que llegó al mundo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}